




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'WorkerStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: WorkerStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case WorkerStatus.Pending:
			case WorkerStatus.ReviewRequired:
				color = "orange--text";
				break;
			case WorkerStatus.Active:
				color = "green--text";
				break;
			case WorkerStatus.Inactive:
				color = "grey--text";
				break;
			default:
				color = "grey-text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case WorkerStatus.Pending:
				text = "PENDING";
				break;
			case WorkerStatus.ReviewRequired:
				text = "REVIEW REQUIRED";
				break;
			case WorkerStatus.Active:
				text = "ACTIVE";
				break;
			case WorkerStatus.Inactive:
				text = "INACTIVE";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
